module.exports = __webpack_public_path__ + "img/like.a3ce2f1a.svg";